import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
export var FinvuConstants;
(function (FinvuConstants) {
    FinvuConstants.VER = '1.1.2';
    FinvuConstants.SID = 'finvu.sid';
    FinvuConstants.UID = 'finvu.userId';
})(FinvuConstants || (FinvuConstants = {}));
export class MessageBuilder {
    static build(msgType, payload, sdkStorage) {
        return {
            header: {
                mid: uuidv4(),
                ts: moment().format(),
                sid: sdkStorage.getValue(FinvuConstants.SID) || '',
                dup: false,
                type: msgType,
            },
            payload,
        };
    }
}
//# sourceMappingURL=index.js.map